import React, { Component, useEffect, useState } from 'react'
import SRCards from '../../components/SRCards'
import {
    Button, Container, FormControl, InputLabel, Select, MenuItem, Paper, TextField,
    Dialog, DialogTitle, DialogContent, DialogActions, Snackbar, Grid,
} from '@material-ui/core'

import CommonServiceApi from '../../services/common-service';
import { Alert } from '@material-ui/lab';
import CompanyApi from '../../services/company.service';
import { CHECK_NON_EMPTY_ARRAY, CHECK_NON_EMPTY_DICTIONARY, CHECK_VALUE } from '../../common/data-validator';
import {  MASTER_COMPANY } from '../../common/constants';
const COUNTRIES: any = {};
const statesByCountryMap: any = {};
const phonenumberFormats: any = {};
export default function RegisterCompanyList() {
    const [companyName, setCompanyName] = useState('');
    const [vertical, setVertical] = useState('');
    const [addressLine1, setAddressLine1] = useState('');
    const [addressLine2, setAddressLine2] = useState('');
    const [country, setCountry] = useState<string>('US');
    const [state, setState] = useState('');
    const [city, setCity] = useState('');
    const [pincode, setPincode] = useState('');
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [phoneNo, setPhoneNo] = useState('');
    const [password, setPassword] = useState('');
    const [timezoneObj, setTimezoneObj] = useState({});
    const [currency, setCurrency] = useState('');
    const [locale, setLocale] = useState('');
    const [language, setLanguage] = useState('');
    const [selectedState, setSelectedState] = useState([]);

    const [dialog, setDialog] = useState(false);
    const [snackBar, setSnackBar] = useState('');
    const [confirmMsg, setConfirmMsg] = useState('');
    const [pageResponse, setPageResponse] = useState('');
    const [errorDialog, setErrorDialog] = useState(false);
    const [allTimezoneOptions, setAllTimezoneOptions] = useState([]);
    const [errorDialogMsg, setErrorDialogMsg] = useState('');
    const [allLocaleOptions, setAllLocaleOptions] = useState([]);
    const [allCurrencyOptions, setAllCurrencyOptions] = useState([]);
    const [countries, setCountries] = useState<any[]>([]);
    const apiservices = new CommonServiceApi();
    const company_apiservices = new CompanyApi();

    const handleCountryChange = (e: React.ChangeEvent<{ value: unknown }>) => {
        const selectedCountry = e.target.value as string; 
        setCountry(selectedCountry); 
        setState(""); 
    };

    const handleTimezoneChange = (e: any) => {
        allTimezoneOptions.forEach((timezone: any) => {
            if (e.target.value === timezone.regionName) {
                setTimezoneObj({
                    regionName: timezone.regionName,
                    code: timezone.abbreviation,
                    name: timezone.displayText,
                    offset: timezone.offsetInMinutes
                })
            }
        })

    }
    
    const getPhoneRegex = (countryKey: string) => {
        // Default to US format if countryKey is not found
        const phonePattern = phonenumberFormats[countryKey as string] || phonenumberFormats["US"];
        const regexStr = phonePattern
        .replace(/\(/g, '\\(')
        .replace(/\)/g, '\\)')
        .replace(/\s/g, '\\s?')
        .replace(/-/g, '[-\\s]?')
        .replace(/#/g, '\\d');
        return new RegExp(`^${regexStr}$`);
    }

    const confirm = (e: any) => {

        var emailRegexp = /[A-Z0-9._%+-]+@[A-Z0-9.-]+.[A-Z]{2,4}$/i;
        var pwdRegexp = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?!.*\s).{8,24}$/;
        var phoneRegexp = getPhoneRegex(country as string);

        if (email === null || email.trim().length === 0) {
            setErrorDialogMsg('Please enter Email');
            setErrorDialog(true);
            return;
        } else if (!emailRegexp.test(email)) {
            setErrorDialogMsg('Please enter a valid Email');
            setErrorDialog(true);
            return;
        } else if (password === null || password.trim().length === 0) {
            setErrorDialogMsg('Please enter Password');
            setErrorDialog(true);
            return;
        } else if (!pwdRegexp.test(password)) {
            setErrorDialogMsg('Password should be minimum 8 characters, maximum 24 characters, and contain one each of:<ul style="list-style:initial;margin-top: 0px;"><li> Upper case alphabet </li><li> Lower case alphabet </li><li> Number </li>');
            setErrorDialog(true);
            return false;
        } else if (phoneNo === null || phoneNo.trim().length === 0) {
            setErrorDialogMsg('Please enter Phone number');
            setErrorDialog(true);
            return false;
        } else if (!phoneRegexp.test(phoneNo.trim())) {
            setErrorDialogMsg('Please enter a valid Phone number');
            setErrorDialog(true);
            return false;
        }
        let msg = `This operation will add a new company named "${companyName}" in the database. Are you sure?`
        setDialog(true);
        setConfirmMsg(msg);
        return;
    }

    const cancel = () => {
        setDialog(false);
        setSnackBar('info');
        setPageResponse(`Register Cancelled.`);
    }

    const register = async () => {
        let params = {
            user: {
                firstName: firstName,
                lastName: lastName,
                username: email,
                email: email,
                password: password,
                cellphone: phoneNo
            },
            company: {
                name: companyName,
                addressLevel1: addressLine1,
                addressLevel2: addressLine2,
                city: city,
                state: state,
                country: country,
                zipcode: pincode,
                addressTypeId: '1',
                vertical: vertical,
                defaultCurrencyCode: currency,
                localeISOCode: locale,
                defaultLanguage: language
            },
            role: {
                name: "Administrator",
                description: "Admin of the company"
            },
            timezone: CHECK_NON_EMPTY_DICTIONARY(timezoneObj) ? timezoneObj : {
                code: "IST",
                offset: -330,
                name: "India Standard Time"
            }
        }
        let response = await company_apiservices.registerNewCompany(params);

        /* Adding mexico in supported countries in customerSettings
        */
        if (response) {            
            const { signupCompany = {} } = response;
            const companyId = signupCompany.id;

            if(country && typeof country === 'string' && country in COUNTRIES){
                const currentCountry = COUNTRIES[country as keyof typeof COUNTRIES];
                const keys = {
                    supportedCountries: [currentCountry]
                };
                const customerSettings = 'customer';
                const result = await apiservices.updateSettings(
                    { ...keys, companyId: Number(companyId) },   
                    customerSettings
                );
                if (result) {
                    setSnackBar('success');
                    setPageResponse(`Added ${currentCountry} in Supported Companies`)
                }
                else {
                    setSnackBar('error');
                    setPageResponse(`Coundn't add ${currentCountry} in supported countries in Customer Settings , please add manually`)
                }
            }
            else{
                const keys = {
                    supportedCountries: [COUNTRIES.US , COUNTRIES.Canada]
                };
                const customerSettings = 'customer';
                const result = await apiservices.updateSettings(
                    { ...keys, companyId: Number(companyId) },   
                    customerSettings
                );
                if (result) {
                    setSnackBar('success');
                    setPageResponse(`Added ${COUNTRIES.US} , ${COUNTRIES.Canada} in Supported Companies`);
                }
                else {
                    setSnackBar('error');
                    setPageResponse(`Coundn't add ${COUNTRIES.US} , ${COUNTRIES.Canada} in supported countries in Customer Settings , please add manually`);
                }
            }
        }
        if (response && response.signupCompany && response.signupCompany.name === companyName) {
            setDialog(false);
            setSnackBar('success');
            setPageResponse("Register Successfully.")
        }
        else {
            let msg;
            if (response && response.sqlMessage) {
                msg = `Register Failed: ${response.sqlMessage}`
            }
            else {
                msg = `Register Failed.`
            }
            setDialog(false);
            setSnackBar('error');
            setPageResponse(msg);
        }
    }

    const onClose = () => {
        setErrorDialog(false)
    }

    const getSupportUser = async () => {
        try{
            let company : any= {
                value: MASTER_COMPANY,
                title: "Default Company (3)"
            }
        const supportUser: any = await company_apiservices.getSupportUserForCompany(company.value) || {};
        console.log(supportUser);

        await localStorage.setItem(
            'selectedCompanyDisplay', company.title
        );
        await localStorage.setItem(
            'selectedCompanyId', company.value
        );
        await localStorage.setItem(
            'supportUserIdOfSelectedCompany', supportUser.id
        );
        await localStorage.setItem(
            'SupportUserDetailsOfSelectedCompany', supportUser
        );
        const googleTokenId = localStorage.getItem("google-token");
        const selectedCompanyId = localStorage.getItem("selectedCompanyId");
        const params = {
            googleTokenId: googleTokenId,
            selectedCompanyId: selectedCompanyId,
            supportUserId: supportUser.id
        }
        const response = await company_apiservices.auth(params);
        await localStorage.setItem(
            'access-token', response.accessToken
        );
        await localStorage.setItem(
            'company-id', company.value
        );
        await localStorage.setItem(
            'user-id', supportUser.id
        );
    }
    catch(err){
        console.log(err);
    }
}

    const fetchStaticData = async () => {
        let timezones = await apiservices.fetchStaticObjectData('timezone');
        setAllTimezoneOptions(timezones);
        let locales = await apiservices.fetchStaticObjectData('locale');
        setAllLocaleOptions(locales);
        let currencies = await apiservices.fetchStaticObjectData('currency');
        setAllCurrencyOptions(currencies);
    }

    const getAllSupportedCountries = async () => {
        const countryArray: any = [];
        let supportedCountries = await company_apiservices.getAllSupportedCompanies();
        supportedCountries.map((country: any) => {
            let countryValue = country.name === "United States" ? "US" : country.name;
            COUNTRIES[countryValue] = countryValue;
            countryArray.push({value: countryValue, label: countryValue});
            statesByCountryMap[countryValue] = country.states.map((currentState:{googleStateValue: string, name: string}) =>({
                value: currentState.googleStateValue,
                label: currentState.name
            }));
            phonenumberFormats[countryValue] = country.countryConfig[0].phoneFormat;
        });
        setCountries(countryArray)
    }

    useEffect(() => {
        getAllSupportedCountries();
        getSupportUser();
        fetchStaticData();
    }, [])

    return (
        <>
            <SRCards />
            <Container>
                <br /> <br />
                <Button className='qbsync_body'
                    onClick={confirm}
                    style={{ margin: 10 }}
                    variant='outlined'> Register </Button>
                <br></br><br></br>
                <Paper
                    style={{
                        padding: 16,
                        margin: 16
                    }}
                    elevation={1}
                >
                    <Grid container spacing={1} style={{ padding: 20 }}>
                        <Grid item xs={6}>
                            <TextField
                                style={{
                                    width: 489
                                }}
                                required
                                label='Company Name'
                                onChange={(e) => {
                                    setCompanyName(e.target.value);
                                }}
                                id='company-name'
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <FormControl>
                                <InputLabel id="demo-simple-select-label" style={{ width: 450 }}>Vertical</InputLabel>
                                <Select
                                    style={{ width: 489 }}
                                    onChange={(e: any) => { setVertical(e.target.value) }}
                                >
                                    <MenuItem value={'Fire'}>Fire</MenuItem>
                                    <MenuItem value={'Electrical'}>Electrical</MenuItem>
                                    <MenuItem value={'HVAC'}>HVAC</MenuItem>
                                    <MenuItem value={'Plumbing'}>Plumbing</MenuItem>

                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                    <Grid container spacing={1} style={{ padding: 20 }}>
                        <Grid item xs={6}>
                            <TextField
                                required
                                style={{ width: 489 }}
                                label='Address Line One'
                                onChange={(e) => {
                                    setAddressLine1(e.target.value);
                                }}
                                id='address1'
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                style={{ width: 489 }}
                                label='Address Line Two'
                                onChange={(e) => {
                                    setAddressLine2(e.target.value);
                                }}
                                id='address2'
                            />
                        </Grid>
                    </Grid>
                    <Grid container spacing={3} style={{ padding: 20 }}>
                        <Grid item xs={3}>
                            <FormControl >
                                <InputLabel id="demo-simple-select-label" style={{ width: 450 }}>Country</InputLabel>
                                <Select
                                    required
                                    value={country}
                                    style={{ width: 200 }}
                                    onChange={handleCountryChange}
                                >
             {countries.map((option) => (
                <option key={option.value} value={option.value}>
                    {option.label}
                </option>
            ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={3}>
                            <FormControl >
                                <InputLabel id="demo-simple-select-label" style={{ width: 450 }}>State</InputLabel>
                                <Select
                                    required
                                    value={state}
                                    style={{ width: 200 }}
                                    onChange={(e: any) => { setState(e.target.value) }}
                                >
                                       {statesByCountryMap[country as string]?.map((state:{value: string, label: string}) => (
                                    <MenuItem key={state.value} value={state.value}>
                                        {state.label}
                                    </MenuItem>
                                ))}
                            </Select>     
                        </FormControl>
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                style={{ width: 200 }}
                                label='City'
                                onChange={(e) => {
                                    setCity(e.target.value)
                                }}
                                id='city'
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                style={{ width: 200 }}
                                label='Pincode'
                                onChange={(e) => {
                                    setPincode(e.target.value)
                                }}
                                id='pincode'
                                error={false}
                            />
                        </Grid>
                    </Grid>
                    <br></br><br></br>
                    <Grid container spacing={3} style={{ padding: 20 }}>
                        <Grid item xs={6}>
                            <TextField
                                style={{ width: 489 }}
                                label='First Name'
                                onChange={(e) => {
                                    setFirstName(e.target.value);
                                }}
                                id='first-name'
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                style={{ width: 489 }}
                                label='Last Name'
                                onChange={(e) => {
                                    setLastName(e.target.value);
                                }}
                                id='last-name'
                            />
                        </Grid>
                    </Grid>
                    <Grid container spacing={3} style={{ padding: 20 }}>
                        <Grid item xs={6}>
                            <TextField
                                type='email'
                                style={{ width: 489 }}
                                label='Email Id'
                                onChange={(e) => {
                                    setEmail(e.target.value)
                                }}
                                id='email'
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                style={{ width: 489 }}
                                label='Phone No'
                                onChange={(e) => {
                                    setPhoneNo(e.target.value);
                                }}
                                id='phone-no'
                            />
                        </Grid>
                    </Grid>
                    <Grid container spacing={3} style={{ padding: 20 }}>
                        <Grid item xs={6}>
                            <TextField
                                style={{ width: 489 }}
                                label='Password'
                                onChange={(e) => {
                                    setPassword(e.target.value);
                                }}
                                id="standard-password-input"
                                type="password"
                            />
                        </Grid>
                    </Grid>
                    <br></br><br></br>
                    <Grid container spacing={3} style={{ padding: 20 }}>
                        <Grid item xs={6}>
                            <FormControl >
                                <InputLabel id="demo-simple-select-label" style={{ width: 489 }}>Timezone</InputLabel>
                                <Select
                                    required
                                    style={{ width: 489 }}
                                    onChange={handleTimezoneChange}
                                >
                                     {CHECK_NON_EMPTY_ARRAY(allTimezoneOptions) && allTimezoneOptions.map((element: any) => (
                                        <MenuItem value={element.regionName + ""} >
                                            {element.displayText}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={6}>
                            <FormControl >
                                <InputLabel id="demo-simple-select-label" style={{ width: 489 }}>Languages</InputLabel>
                                <Select
                                    style={{ width: 489 }}
                                    onChange={(e: any) => { setLanguage(e.target.value) }}
                                    defaultValue='English'>
                                    <MenuItem value='English'>English</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                    <Grid container spacing={3} style={{ padding: 20 }}>
                        <Grid item xs={6}>
                            <FormControl >
                                <InputLabel id="demo-simple-select-label" style={{ width: 489 }}>Currency</InputLabel>
                                <Select
                                    required
                                    style={{ width: 489 }}
                                    onChange={(e: any) => { setCurrency(e.target.value) }}
                                >
                                    {CHECK_NON_EMPTY_ARRAY(allCurrencyOptions) && allCurrencyOptions.map((element: any) => (
                                        <MenuItem value={element.code + ""}>
                                            {element.name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={6}>
                            <FormControl >
                                <InputLabel id="demo-simple-select-label" style={{ width: 489 }}>Locale</InputLabel>
                                <Select
                                    required
                                    style={{ width: 489 }}
                                    onChange={(e: any) => { setLocale(e.target.value) }}
                                >
                                    {CHECK_NON_EMPTY_ARRAY(allLocaleOptions) && allLocaleOptions.map((element: any) => (
                                        <MenuItem value={element.isoCode + ""}>
                                            {element.displayText}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                </Paper>

                <Dialog
                    open={dialog}
                    onClose={() => {
                        setDialog(false)
                    }}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description">
                    <DialogTitle id="alert-dialog-title">
                        {'Confirmation!'}
                    </DialogTitle>
                    <DialogContent>
                        {confirmMsg}
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={
                                () => {
                                    setConfirmMsg('Processing...')
                                    register()
                                }
                            }
                        >
                            Confirm
                        </Button>
                        <Button
                            onClick={
                                () => cancel()
                            }
                            autoFocus
                        >
                            Cancel
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog
                    open={errorDialog}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description">
                    <DialogContent>
                        {errorDialogMsg}
                    </DialogContent>
                    <Button onClick={onClose}>Ok</Button>
                </Dialog>
                <Snackbar
                    open={snackBar === '' ? false : true}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right',
                    }}
                    autoHideDuration={6000}
                    onClose={() => {
                        setSnackBar('')
                    }}
                >
                    <Alert
                        severity={snackBar === 'error' ? 'error' : 'success'}
                        onClose={() => {
                            setSnackBar('')
                        }
                        }>
                        {pageResponse}
                    </Alert>
                </Snackbar>
            </Container>
        </>
    )
}
